import { logger } from 'src/lib'
import { config } from '@/config'

interface ConnectProps {
  onReconnect?: () => void
  onMessage: (event: MessageEvent<any>) => void
}

export class SocketService {
  private static instance: WebSocket

  public static connect(props: ConnectProps) {
    this.instance = new WebSocket(config.api.socket)
    this.instance.onopen = () => {
      logger.log('The connection is established')
    }
    this.instance.onerror = (error) => logger.error(error)
    this.instance.onclose = (event) => {
      if (event.wasClean) {
        logger.log('The connection was closed cleanly')
      } else {
        logger.log('Socket is closed. Reconnect will be attempted in 1 second.', event.reason)
        setTimeout(() => {
          this.connect(props)
          if (typeof props.onReconnect === 'function') props.onReconnect()
        }, 1000)
      }
    }
    this.instance.onmessage = props.onMessage
  }

  public static getInstance() {
    return this.instance
  }

  public static close() {
    this.instance.close()
  }

  public static send(message: Record<string, any>) {
    try {
      if (this.instance.readyState === this.instance.OPEN) {
        this.instance.send(JSON.stringify(message))
      } else if (this.instance.readyState === this.instance.CONNECTING) {
        logger.log('The connection is in progress. The resend will be attempted in 1 second.', message)
        setTimeout(() => this.send(message), 1000)
      } else {
        logger.warn("The connection was closed, message won't be send", message)
      }
    } catch (error) {
      logger.error(error)
    }
  }
}
